module.exports = __webpack_public_path__ + "static/media/broker_landing_2.956db3ed.png";